"use strict";
var appn;
(function (appn) {
    var dialog;
    (function (dialog) {
        let MediaType;
        (function (MediaType) {
            MediaType["Audio"] = "Audio";
            MediaType["Image"] = "Image";
            MediaType["Video"] = "Video";
        })(MediaType = dialog.MediaType || (dialog.MediaType = {}));
        function alert(arg) {
            appn.dialog.hide();
            bootbox.alert.apply(null, arguments);
        }
        dialog.alert = alert;
        function confirm(arg) {
            appn.dialog.hide();
            bootbox.confirm.apply(null, arguments);
        }
        dialog.confirm = confirm;
        function prompt(arg) {
            appn.dialog.hide();
            bootbox.prompt.apply(null, arguments);
        }
        dialog.prompt = prompt;
        function custom(arg) {
            appn.dialog.hide();
            bootbox.dialog.apply(null, arguments);
        }
        dialog.custom = custom;
        function viewMedia(url, mediaName, mediaType, downloadBtn = true) {
            let msgHtml = appn.emptyString;
            let boxTitle = appn.emptyString;
            let name = mediaName;
            switch (mediaType) {
                case MediaType.Audio:
                    name = !name ? T('Audio Download') : name;
                    boxTitle = `<i class="fa fa-volume"></i> ${name}`;
                    msgHtml = `<audio id="popupAudio" controls>` +
                        `<source src="${url}" type = "audio/mpeg" >` +
                        `<source src="${url}" type="audio/wav" ></audio>`;
                    break;
                case MediaType.Video:
                    name = !name ? T('Video Download') : name;
                    boxTitle = `<i class="fa fa-video"></i> ${name}`;
                    msgHtml = `<video id="popupVideo" controls preload="auto">` +
                        `<source src="${url}" type = "video/mp4" ></video>`;
                    break;
                default:
                    name = !name ? T('Image Download') : name;
                    boxTitle = `<i class="fa fa-image"></i> ${name}`;
                    msgHtml = `<img class="img-fluid center-block image-checkered-back" src="${url}">`;
                    break;
            }
            var btns = {};
            if (downloadBtn)
                btns.btnDownload = downloadButton(url, name);
            custom({
                message: `<div class="text-center">${msgHtml}</div>`,
                title: boxTitle,
                modalColor: 'modal-info',
                closeButton: true,
                size: 'large',
                buttons: btns
            });
        }
        dialog.viewMedia = viewMedia;
        function viewMediaFromElement(element) {
            let name = element.data('name');
            let url = element.data('url');
            let media = element.data('media');
            let mediaType = MediaType.Image;
            if (!url)
                url = String(element.attr('src'));
            if (!name) {
                const idx = url.lastIndexOf('/');
                const dot = url.lastIndexOf('.');
                name = url.substr(idx + 1, dot - idx - 1);
            }
            if (!media)
                media = 'image';
            media = media.toLowerCase();
            switch (media) {
                case 'video':
                    mediaType = MediaType.Video;
                    break;
                case 'audio':
                    mediaType = MediaType.Audio;
                    break;
                default:
                    mediaType = MediaType.Image;
            }
            viewMedia(url, name, mediaType);
        }
        dialog.viewMediaFromElement = viewMediaFromElement;
        function downloadButton(mediaHref, fileName) {
            return {
                label: T('Download'),
                className: 'btn-success',
                callback: function () {
                    const element = document.createElement('a');
                    element.setAttribute('href', mediaHref);
                    element.setAttribute('download', fileName);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                    return true;
                }
            };
        }
        function showBillUpgrade() {
            $('.upgradeOverlay').modal('show');
        }
        dialog.showBillUpgrade = showBillUpgrade;
        function showBillUpgradeOnClick(afterShownCallback) {
            const $billUpgradeReq = $('[showBillUpgradeOnClick]');
            if ($billUpgradeReq.is('option')) {
                const $parentSelect = $billUpgradeReq.closest('select');
                $parentSelect.on('change', function (e) {
                    if ($('option:selected', this).is('[showBillUpgradeOnClick]')) {
                        showBillUpgrade();
                        if (afterShownCallback)
                            afterShownCallback();
                    }
                });
                return;
            }
            $billUpgradeReq.on('click', function () {
                if ($('option:selected', this).is('[showBillUpgradeOnClick]')) {
                    showBillUpgrade();
                    if (afterShownCallback)
                        afterShownCallback();
                }
            });
        }
        dialog.showBillUpgradeOnClick = showBillUpgradeOnClick;
        function hide() {
            if ($('.modal.show').length > 0)
                $('.modal.show').modal('hide');
        }
        dialog.hide = hide;
        function showLoading(withMessage) {
            const $preloader = $('.preloader');
            withMessage = withMessage !== null && withMessage !== void 0 ? withMessage : T('Loading...');
            $preloader.find('.appn-loading-text-container p.lead').text(withMessage);
            $preloader.show(0);
        }
        dialog.showLoading = showLoading;
        function hideLoading() {
            const $preloader = $('.preloader');
            $preloader.addClass('background-blur').delay(500).queue(function (next) {
                $preloader.removeClass('background-blur');
                next();
            }).hide(0);
        }
        dialog.hideLoading = hideLoading;
        function showContentSpinner($container) {
            const $contentSpinner = $('<div>', {
                class: 'content-spinner',
                title: T('Loading Content...')
            });
            const $spinnerElement = $('<div>', {
                class: 'appn-spinner spinner-border text-primary'
            });
            $spinnerElement.appendTo($contentSpinner);
            $contentSpinner.appendTo($container);
        }
        dialog.showContentSpinner = showContentSpinner;
        function removeContentSpinner($container) {
            $container.find('.content-spinner').remove();
        }
        dialog.removeContentSpinner = removeContentSpinner;
        function showBodySpinner() {
            const $contentSpinner = $('<div>', {
                class: 'content-spinner',
                title: T('Loading Content...')
            });
            const $spinnerElement = $('<div>', {
                class: 'appn-spinner spinner-border text-primary'
            });
            $spinnerElement.appendTo($contentSpinner);
            $contentSpinner.appendTo($('body'));
        }
        dialog.showBodySpinner = showBodySpinner;
        function removeBodySpinner() {
            $('body').find('.content-spinner').remove();
        }
        dialog.removeBodySpinner = removeBodySpinner;
        function toggleAttachmentNamesSelect(attachmentNames, formGroupFileName, format) {
            const fileNameSelect = $(`${format ? '#FileName.' + format : '#FileName'}`);
            fileNameSelect.html(appn.emptyString);
            if (attachmentNames && attachmentNames.length > 0) {
                fileNameSelect.append(appn.elementBuilder.buildOptionsList(attachmentNames, 'Default'));
                formGroupFileName.show();
                if (format)
                    $('input[name="SelectedFileName"]').val(String($(`.card-planejane.${format} .${format}#FileName`).val()));
                return;
            }
            formGroupFileName.hide();
            if (format)
                $('input[name="SelectedFileName"]').val(appn.emptyString);
        }
        dialog.toggleAttachmentNamesSelect = toggleAttachmentNamesSelect;
    })(dialog = appn.dialog || (appn.dialog = {}));
})(appn || (appn = {}));
